import React from 'react';
import { Link } from 'react-router-dom';

const LANGUAGES = [
  { code: 'RU', label: 'РУ' },
  { code: 'KY', label: 'KG' },
  { code: 'EN', label: 'EN' },
];

function Header({ language, onSelectLanguage }) {
  return (
    <div className="site-header">
      <Link to={`/?lang=${language}`} className="brand-lockup">
        <img alt="Kid Security" src="/logo.avif" className="site-header-logo" />
        <span className="brand-separator">×</span>
        <img alt="Mega" src="/mega-logo.png" className="partner-logo" />
      </Link>

      <div className="language-switcher" role="group" aria-label="Language">
        {LANGUAGES.map(({ code, label }) => (
          <button
            key={code}
            type="button"
            className={`language-option ${language === code ? 'active' : ''}`}
            onClick={() => onSelectLanguage(code)}
          >
            {label}
          </button>
        ))}
      </div>
    </div>
  );
}

export default Header;
